/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import abstractContractClaimTranslations from "./abstractContractClaimTranslations";

const dataLeakContractTranslations = {
  label: "Datenweitergabe",
  salesChannel: {
    question: "Wo haben Sie den Mobilfunkvertrag abgeschlossen?",
    options: {
      providerWebsite: {
        label: "Im Internet über die Website des Anbieters",
      },
      comparisonPortal: {
        label: "Im Internet über ein Vergleichsportal (CHECK24, Verivox, ...)",
      },
      localStore: {
        label: "Vor Ort im Laden",
      },
      phone: {
        label: "Per Telefon",
      },
      other: {
        label: "Auf anderem Wege",
      },
    },
  },
  contractNumber: {
    question: "Wie lautet Ihre Kundennummer bei Ihrem Anbieter?",
    label: "Kundennummer",
    helperText: "Sie finden diese Nummer z.B. auf Ihren Rechnungen oder in den E-Mails des Anbieters",
  },
  hadProblemsDueToCreditRating: {
    question: "1. Haben Sie schon einmal wegen Ihrer Bonität / Ihrem Scoring einen Kredit/Vertrag nicht abschließen können?",
    options: {
      yes: { label: "Ja" },
      no: { label: "Nein" },
    },
  },
  creditRatingProblemsDescription: {
    label: "Ergänzende Angaben",
    placeholder: "Weitere Angaben zu Problemen bei Vertragsabschluss / Kredit",
    errors: {
      tooShort: "Bitte geben Sie mindestens 50 Buchstaben ein",
    },
  },
  purchasesPlannedInTheNearFuture: {
    question: "2. Welche dieser Käufe/Dienstleistungen wollen Sie in naher Zukunft tätigen/erwerben und haben Sorgen, dass es dort Probleme geben könnte?",
    options: {
      vehicle: { label: "Kauf eines Fahrzeugs" },
      housePurchase: { label: "Hauskauf / Wohnungskauf" },
      relocation: { label: "Umzug in neue Wohnung / Haus (zur Miete)" },
      mobilePhoneContract: { label: "Abschluss / Wechsel Mobilfunkvertrag" },
      electricityProvider: { label: "Abschluss / Wechsel Stromanbieter" },
      gasProvider: { label: "Abschluss/ Wechsel Gasanbieter" },
      invoicePurchase: { label: "Rechnungskauf" },
      borrowing: { label: "Kreditaufnahme" },
      debtConversion: { label: "Umschuldung / Anschlusskredit" },
      other: { label: "Anderes" },
      none: { label: "Keine der obigen Optionen" },
    },
  },
  emotionalState: {
    question: "3. Beschreiben Sie bitte Ihre Gefühlslage durch die Datenweitergabe, indem Sie zutreffendes anklicken.",
    options: {
      lossOfControl: { label: "Ich empfinde einen Kontrollverlust, da ich nicht weiß, welche Dienstleister ebenfalls Zugriff auf meine Daten erhalten haben." },
      anxiety: { label: "Manchmal leide ich unter Angstzuständen." },
      uncomfortableAboutScoring: { label: "Es bereitet mir Unwohlsein zu wissen, dass Personen mit einem guten Scoring bevorzugt behandelt werden." },
      qualityOfSleep: { label: "Meine Schlafqualität ist oft beeinträchtigt, da ich mir Sorgen wegen meiner Bonität mache." },
      worryAboutFutureFinancialObligations: {
        label: "Ich mache mir häufig Gedanken darüber, ob ich meinen zukünftigen finanziellen Verpflichtungen noch nachkommen kann.",
      },
      helpless: {
        label:
          "Ich fühle mich hilflos und der Macht der Auskunfteien ausgeliefert, da meine gesamte finanzielle Identität von einem Scoring abhängt und ich nicht weiß, wo die Daten verwendet werden und ob ich es rückgängig machen kann.",
      },
      lossOfTrust: {
        label: "Mein Vertrauen in den Umgang mit meinen Daten ist erschüttert, da ich nicht weiß, wer meine Daten sonst noch weitergibt oder darauf zugreift.",
      },
      violationOfHonor: {
        label:
          "Es fühlt sich wie eine Beleidigung/Stigmatisierung oder eine Ehrverletzung an, da mir ohne vollständige Informationen über mich selbst ein Stempel durch das Scoring aufgedrückt wird.",
      },
      lossOfConfidence: {
        label:
          "Ich verliere das Vertrauen in potenzielle Vertragspartner, wenn schon bekannte deutsche Unternehmen bei nicht hohen monatlichen Forderungen Eintragungen in die Auskunfteien vornehmen.",
      },
    },
  },
  worriesFrequency: {
    question: "4. Beschreiben Sie die Häufigkeit, mit der Ihre Sorgen auftreten.",
    options: {
      daily: { label: "Täglich" },
      weekly: { label: "Wöchentlich" },
      monthly: { label: "Monatlich" },
      other: { label: "Anderes" },
    },
    errors: {
      required: "Bitte wählen sie eine Häufigkeit aus.",
    },
  },
  worriesFrequencyOther: {
    label: "Ergänzende Angaben",
    placeholder: "Weitere Angaben zur Häufigkeit Ihrer Sorgen",
  },
  personalStatement: {
    label: "Ergänzende Angaben",
    placeholder: "Weitere Angaben zu Befürchtungen oder negativen Erfahrungen (optional)",
  },
  personalAffectionClient: {
    label: "Aussage zu Ihrer persönlichen Betroffenheit",
  },
  ...abstractContractClaimTranslations,
};

export default dataLeakContractTranslations;
